import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [pagesOpen, setPagesOpen] = useState(false);

    const isActive = (path) => location.pathname === path ? 'active' : '';
    const toggleMenu = () => setMenuOpen(!menuOpen);
    const closeMenu = () => { setMenuOpen(false); setPagesOpen(false); };
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);

        const preloder = document.getElementById('preloder');
        const loader = document.querySelector('.loader');
        setTimeout(() => {
            if (loader) { loader.style.opacity = '0'; loader.style.transition = 'opacity 0.3s ease'; }
            if (preloder) {
                preloder.style.opacity = '0';
                preloder.style.transition = 'opacity 0.5s ease';
                setTimeout(() => { preloder.style.display = 'none'; }, 500);
            }
        }, 800);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <style>{`
                /* ===== PRELOADER ===== */
                #preloder {
                    position: fixed;
                    width: 100%; height: 100%;
                    top: 0; left: 0;
                    z-index: 999999;
                    background: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 1;
                    transition: opacity 0.5s ease;
                }

                /* ===== OVERLAY ===== */
                .mob-overlay {
                    display: none;
                    position: fixed;
                    top: 0; left: 0;
                    width: 100%; height: 100%;
                    background: rgba(0,0,0,0.5);
                    z-index: 9998;
                }
                .mob-overlay.open { display: block; }

                /* ===== SIDEBAR ===== */
                .mob-sidebar {
                    position: fixed;
                    top: 0; left: -300px;
                    width: 280px; height: 100%;
                    background: #fff;
                    z-index: 9999;
                    transition: left 0.3s ease;
                    overflow-y: auto;
                    padding: 20px;
                    box-shadow: 2px 0 10px rgba(0,0,0,0.2);
                }
                .mob-sidebar.open { left: 0; }
                .mob-close {
                    text-align: right;
                    font-size: 22px;
                    cursor: pointer;
                    color: #333;
                    margin-bottom: 15px;
                }
                .mob-logo { margin-bottom: 20px; }
                .mob-logo img { height: 40px; }
                .mob-nav ul {
                    list-style: none !important;
                    padding: 0 !important;
                    margin: 0 !important;
                }
                .mob-nav ul li { border-bottom: 1px solid #eee; }
                .mob-nav ul li a {
                    display: block;
                    padding: 13px 5px;
                    color: #222 !important;
                    font-size: 15px;
                    font-weight: 600;
                    text-decoration: none !important;
                }
                .mob-nav ul li a:hover,
                .mob-nav ul li.active > a { color: #7b5ea7 !important; }
                .mob-info {
                    margin-top: 20px;
                    list-style: none;
                    padding: 0;
                }
                .mob-info li { padding: 6px 0; font-size: 13px; color: #555; }
                .mob-info li i { color: #7b5ea7; margin-right: 8px; }

                /* ===== MOBILE HEADER BAR ===== */
                /* Hidden by default, shown only on mobile */
                .mobile-header-bar {
                    display: none;
                }

                @media (max-width: 991px) {
                    /* Show mobile bar */
                    .mobile-header-bar {
                        display: flex !important;
                        align-items: center !important;
                        justify-content: space-between !important;
                        padding: 10px 16px !important;
                        background: #fff !important;
                        border-bottom: 1px solid #eee !important;
                        position: relative !important;
                        z-index: 100 !important;
                    }
                    .mobile-header-bar .mob-header-logo img {
                        height: 36px;
                        width: auto;
                    }
                    .mob-hamburger {
                        width: 40px !important;
                        height: 40px !important;
                        background: #7b5ea7 !important;
                        border-radius: 6px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        cursor: pointer !important;
                        flex-shrink: 0 !important;
                    }
                    .mob-hamburger span {
                        color: #fff !important;
                        font-size: 17px !important;
                        line-height: 1 !important;
                    }

                    /* Hide desktop header completely on mobile */
                    .header {
                        display: none !important;
                    }
                }

                @media (min-width: 992px) {
                    .mobile-header-bar {
                        display: none !important;
                    }
                }
            `}</style>

            {/* ===== PRELOADER ===== */}
            <div id="preloder">
                <div className="loader"></div>
            </div>

            {/* ===== MOBILE OVERLAY ===== */}
            <div className={`mob-overlay ${menuOpen ? 'open' : ''}`} onClick={closeMenu}></div>

            {/* ===== MOBILE SIDEBAR ===== */}
            <div className={`mob-sidebar ${menuOpen ? 'open' : ''}`}>
                <div className="mob-close" onClick={closeMenu}>
                    <i className="fa fa-times"></i>
                </div>
                <div className="mob-logo">
                    <Link to="/" onClick={closeMenu}>
                        <img src="/img/le vp.png" alt="Logo" />
                    </Link>
                </div>
                <nav className="mob-nav">
                    <ul>
                        <li className={isActive('/')}><Link to="/" onClick={closeMenu}>Home</Link></li>
                        <li className={isActive('/about')}><Link to="/about" onClick={closeMenu}>About</Link></li>
                        <li className={isActive('/services')}><Link to="/services" onClick={closeMenu}>Services</Link></li>
                        <li className={isActive('/contact')}><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
                        <li className={isActive('/joinus')}><Link to="/joinus" onClick={closeMenu}>Join Us</Link></li>
                    </ul>
                </nav>
                <ul className="mob-info">
                    <li><i className="fa fa-map-marker"></i> 203A Sovereign shopper NR, Sindhu Seva Samiti School Adajan</li>
                    <li><i className="fa fa-phone"></i> 8401064678</li>
                    <li><i className="fa fa-envelope"></i> support@vijayprimes.com</li>
                </ul>
            </div>

            {/* ===== MOBILE HEADER BAR ===== */}
            {/* This is a completely separate bar only shown on mobile */}
            <div className="mobile-header-bar">
                <div className="mob-header-logo">
                    <Link to="/">
                        <img src="/img/le vp.png" alt="Logo" />
                    </Link>
                </div>
                <div className="mob-hamburger" onClick={toggleMenu}>
                    <span className="fa fa-bars"></span>
                </div>
            </div>

            {/* ===== DESKTOP HEADER ===== */}
            <header className={`header ${scrolled ? 'sticky' : ''}`}>
                <div className="header__top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-9">
                                <ul className="header__top__widget">
                                    <li><i className="fa fa-map-marker"></i>203A Sovereign shopper NR, Sindhu Seva Samiti School Adajan</li>
                                    <li><i className="fa fa-phone"></i>8401064678</li>
                                    <li><i className="fa fa-envelope"></i>support@vijayprimes.com</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="header__logo">
                                <Link to="/"><img src="/img/le vp.png" alt="Logo" /></Link>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="header__nav">
                                <nav className="header__menu">
                                    <ul>
                                        <li className={isActive('/')}><Link to="/">Home</Link></li>
                                        <li className={isActive('/about')}><Link to="/about">About</Link></li>
                                        <li className={isActive('/services')}><Link to="/services">Services</Link></li>
                                        <li className={isActive('/contact')}><Link to="/contact">Contact</Link></li>
                                        <li className={isActive('/joinus')}><Link to="/joinus">Join us</Link></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Navbar;